import { createRoot } from "react-dom/client";
import { useState } from "react";
import VerificationInput from "react-verification-input";
import { I18n } from "aws-amplify";
import { CheckboxField } from "@aws-amplify/ui-react";

import "./styles.css";

const CODE_INPUT_ID = "CODE_INPUT";
const STORAGE_KEY = "rememberDevice";

const findElementByTextContent = (rootElement, searchText) => {
  for (let i = 0; i < rootElement.length; i++) {
    const element = rootElement[i];
    if (element.textContent.includes(searchText)) {
      return element;
    }
  }
  return null;
};

const RememberDeviceCheckbox = () => {
  const [rememberDevice, setRememberDevice] = useState(false);

  const handleChange = (e) => {
    const checked = e.target.checked;
    setRememberDevice(checked);
    sessionStorage.setItem(STORAGE_KEY, checked.toString());
    console.log('Remember device checkbox changed:', checked);
  };

  return (
    <CheckboxField
      name="rememberDevice"
      label={I18n.get('confirmSignIn.rememberDevice')}
      checked={rememberDevice}
      onChange={handleChange}
      className="remember-device-checkbox"
    />
  );
};

const addCheckboxToForm = (submitButton) => {
  // Check if checkbox already added
  if (document.getElementById('remember-device-checkbox-container')) {
    return;
  }

  if (submitButton) {
    // Create container for checkbox
    const checkboxContainer = document.createElement("div");
    checkboxContainer.id = 'remember-device-checkbox-container';
    checkboxContainer.style.marginTop = '1rem';
    checkboxContainer.style.marginBottom = '1rem';
    checkboxContainer.style.display = 'flex';
    checkboxContainer.style.justifyContent = 'center';

    // Render checkbox using React
    const root = createRoot(checkboxContainer);
    root.render(<RememberDeviceCheckbox />);

    // Insert checkbox before the submit button
    submitButton.parentElement.insertBefore(checkboxContainer, submitButton);
  }
};

const replaceCodeInput = () => {
  const newInputContainer = document.getElementById(CODE_INPUT_ID);

  if (!newInputContainer) {
    const newElement = document.createElement("div");
    newElement.id = CODE_INPUT_ID;
    const referenceElement = document.getElementsByName("confirmation_code")[0];

    if (referenceElement) {
      const inputLabelElement = findElementByTextContent(
        document.getElementsByTagName("label"),
        I18n.get("Code *"),
      );

      const submitButtonElement = findElementByTextContent(
        document.getElementsByTagName("button"),
        I18n.get("Confirm"),
      );

      const root = createRoot(newElement);
      root.render(
        <VerificationInput
          validChars="0-9"
          placeholder=""
          autoFocus
          inputProps={{
            inputMode: "numeric",
            name: "confirmation_code",
            required: true,
            autoComplete: 'off',
          }}
        />
      );
      if (referenceElement && referenceElement.parentElement) {
        referenceElement.parentElement.replaceChild(
          newElement,
          referenceElement,
        );
      }
      if (inputLabelElement) {
        inputLabelElement.style.textAlign = "center";
        inputLabelElement.style.fontSize = "1rem";
      }

      addCheckboxToForm(submitButtonElement);
    }
  }
};

export default replaceCodeInput;
